import React from 'react';
import { ACTION_TYPES, PRIORITIES } from '../constants';

const RequestDetailsSection = ({ 
  formData, 
  accountTypes,
  isLoadingAccountTypes,
  isSubmitting, 
  handleChange 
}) => {
  return (
    <>
      <div className="col-span-full mt-4">
        <h3 className="text-black font-semibold mb-4 font-poppins text-lg">
          Request Details
        </h3>
      </div>

      <div className="relative">
        <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
          Action Type <span className="text-red-500">*</span>
        </label>
        <select
          name="actionType"
          value={formData.actionType}
          onChange={handleChange}
          disabled={isSubmitting}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins"
        >
          <option value="">Select Action Type</option>
          {ACTION_TYPES.map((type) => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </select>
      </div>

      <div className="relative">
        <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
          Account Type <span className="text-red-500">*</span>
        </label>
        <select
          name="accountType"
          value={formData.accountType}
          onChange={handleChange}
          disabled={isSubmitting || isLoadingAccountTypes}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins"
        >
          <option value="">Select Account Type</option>
          {accountTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
        {isLoadingAccountTypes && (
          <div className="flex items-center mt-2">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
            <span className="text-sm text-gray-600 font-poppins">Loading account types...</span>
          </div>
        )}
      </div>

      <div className="relative">
        <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
          Priority <span className="text-red-500">*</span>
        </label>
        <select
          name="priority"
          value={formData.priority}
          onChange={handleChange}
          disabled={isSubmitting}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins"
        >
          <option value="">Select Priority</option>
          {PRIORITIES.map((priority) => (
            <option key={priority.value} value={priority.value}>
              {priority.label}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default RequestDetailsSection; 